import { getData, postData } from "@/utils";

export async function getGuestCards(id) {
  try {
    const response = await getData(`/pos/guests/${id}/cards/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getGuestNotes(id) {
  try {
    const response = await getData(`/pos/guests/${id}/notes/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addGuestNote(id, payload) {
  try {
    const response = await postData(`/pos/guests/${id}/notes/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}
